export default __webpack_public_path__ + "static/media/01.cc103b91.png";